import styled from 'styled-components'

const StyledHero= styled.header`
    min-height: 60vh;
    margin-top:40px;
    background: url(${props=>props.img}) center/cover no-repeat;
    display: flex;
    width:100vw;
    align-items: center;
    justify-content: center;
    @media screen and (max-width:768px){
    background: url(${props=>props.mob}) no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 100vh;
    }
`;
export default StyledHero